// Apolo IDE — Compare Mode defaults (Sprint v4 Epic S1 WS S1.2).
//
// Single source of truth for Compare Mode's default model lineup.
// Atualizado 2026-09-30: Sonnet 5.5, Opus 5.5, DeepSeek V4.1 Flash.

import { findModel, MODEL_REGISTRY } from './modelRegistry.js';

export const COMPARE_DEFAULT_MODELS = [
  'anthropic/claude-sonnet-5-5',
  'anthropic/claude-opus-5-5',
  'deepseek/deepseek-flash',
];

export const COMPARE_MIN_MODELS = 2;
export const COMPARE_MAX_MODELS = 6;

/** Return the registry entries for the default model lineup (preserving order). */
export function getCompareDefaultModels() {
  return COMPARE_DEFAULT_MODELS.map((id) => findModel(id)).filter(Boolean);
}

/** Validate a list of model ids for Compare Mode (count + registry membership). */
export function validateCompareSelection(ids) {
  if (!Array.isArray(ids)) return { ok: false, error: 'models must be an array' };
  if (ids.length < COMPARE_MIN_MODELS) {
    return { ok: false, error: `select at least ${COMPARE_MIN_MODELS} models` };
  }
  if (ids.length > COMPARE_MAX_MODELS) {
    return { ok: false, error: `select at most ${COMPARE_MAX_MODELS} models` };
  }
  const seen = new Set();
  for (const id of ids) {
    if (typeof id !== 'string' || !findModel(id)) {
      return { ok: false, error: `unknown model: ${String(id)}` };
    }
    if (seen.has(id)) {
      return { ok: false, error: `duplicate model: ${id}` };
    }
    seen.add(id);
  }
  return { ok: true, error: null };
}

/**
 * Group model entries by provider for the model picker — same shape as
 * modelRegistry.groupByProvider but filtered to a subset, used by the
 * "+ add model" picker so users only browse models that exist.
 */
export function availableCompareModels() {
  // Sort same way as modelRegistry to keep picker order predictable.
  return MODEL_REGISTRY.slice().sort((a, b) => {
    if (a.provider === b.provider) return a.label.localeCompare(b.label);
    return a.provider.localeCompare(b.provider);
  });
}
